import { useAgentCreditAllowanceInChatChrome } from '@/components/ui/agent-credit-allowance-banner/useAgentCreditAllowanceInChatChrome';
import {
  WorkCreditAllowanceChromeProvider,
  type UseWorkCreditAllowanceChrome,
} from '@heidi/agents';
import { type JSX, type ReactNode } from 'react';

const STUB_CHROME = {
  composerDockLeading: null,
  transcriptTrailing: null,
  hideFollowUpQuestions: false,
  sendDisabled: false,
  forceEvidenceOnlyOnSend: false,
} as const;

const useStubCreditChrome: UseWorkCreditAllowanceChrome = () => STUB_CHROME;

const useLiveCreditChrome: UseWorkCreditAllowanceChrome = (options) =>
  useAgentCreditAllowanceInChatChrome(true, options);

// Layout suites mock `@/features/flags` as a stub bag and skip QueryClient.
// Suites that need real chrome mount WorkCreditAllowanceChromeProvider themselves.
const useWorkCreditAllowanceChrome: UseWorkCreditAllowanceChrome =
  process.env.NODE_ENV === 'test' ? useStubCreditChrome : useLiveCreditChrome;

/** Layout-scoped. The adapter is one identity and is never conditional. */
export const WorkCreditAllowanceChromeHost = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <WorkCreditAllowanceChromeProvider useChrome={useWorkCreditAllowanceChrome}>
    {children}
  </WorkCreditAllowanceChromeProvider>
);
